import type { PatentSearchResponse, PatentFilterContext } from '../apis/fto-pro-api';
import type { PatentInfo } from '../types';
import { CurrentStep } from '../enums';

/**
 * 专利缓存服务接口
 * 负责缓存和检索专利搜索、过滤结果
 */
export interface PatentCacheService {
    /**
     * 存储搜索结果
     * @param searchIndex - 搜索索引
     * @param response - 搜索响应结果
     */
    storeSearchResult(searchIndex: number, response: PatentSearchResponse): void;

    /**
     * 存储过滤结果
     * @param searchIndex - 搜索索引
     * @param filterIndex - 过滤索引
     * @param response - 过滤响应结果
     */
    storeFilterResult(searchIndex: number, filterIndex: number, response: PatentFilterContext): void;

    /**
     * 获取专利数据
     * @param searchIndex - 搜索索引
     * @param filterIndex - 过滤步骤（可选，如果不提供则返回搜索结果）
     * @returns 专利信息数组
     */
    getPatentData(searchIndex: number, filterIndex?: CurrentStep): PatentInfo[];

    /**
     * 更新专利选择状态
     * @param searchIndex - 搜索索引
     * @param patentId - 专利ID
     * @param selected - 选择状态
     * @returns 更新是否成功
     */
    updatePatentSelection(searchIndex: number, patentId: string, selected: boolean): boolean;

    /**
     * 清除指定搜索索引的所有数据
     * @param searchIndex - 搜索索引
     */
    clearSearchData(searchIndex: number): void;

    /**
     * 清除所有数据
     */
    clearAllData(): void;
}

export const PatentCacheService = Symbol('PatentCacheService');
